// extracted by mini-css-extract-plugin
module.exports = {"List":"OfferList_List__1gTpJ","Empty":"OfferList_Empty__3jbOH","Header":"OfferList_Header__1ro0N"};